export default __webpack_public_path__ + "static/media/istanbul.77151328.png";